export const n = $state({ l: false })

export const updateN = (state: boolean) => (n.l = state)
